<template>
    <div class="page">
        <Headers></Headers>
        <div class="banner">
            <!-- 顶部标题 -->
            <div class="pdfPageTitle mg_t">
                <div class="pdfPageTitle-txt">
                    <span class="pdfPageTitle-txt__first">绿色供应链</span>
                    <span class="pdfPageTitle-txt__second">(权重{{PdftStore.fromData.spaceEmissionGreenSupply?.weight}}%)</span>
                </div>
                <!-- <div class="pdfPageTitle-icon">
                    <img src="@/assets/img/page10.png">
                </div> -->
            </div>

            <!-- 顶部数据 -->
            <div class="top_box">
                <div class="left">
                    <div class="title mg_b">核查结论</div>
                    <div class="tx">{{PdftStore.fromData.spaceEmissionGreenSupply?.verificationConclusion}}</div>
                </div>
            </div>

            <!-- 明细 -->
            <div class="min_box">
                <div class="title">碳中和进程评级得分明细</div>
                <List :type=6  :id="'listPdfReport6'"/>
            </div>

            <!-- 数据图表 -->
            <div class="banner_box">
                <div class="left_box">
                    <div class="top_box_banner">
                        <div class="title">绿色供应链得分：</div>
                        <div class="jindu" v-if="PdftStore.fromData.spaceEmissionGreenSupply">
                            <NewPro
                            :name="'page10progess'"
                            :centerNum="0"
                            :minScore="0"
                            :centerScore="100"
                            :leftScore="PdftStore.fromData.spaceEmissionGreenSupply?.updateScore"
                            :maxEmiss="'无计划或措施'"
                            :minEmiss="'多样、完整、有效的管理'"
                            :maxScore="100"
                            :rightMinScore="0"
                            :rightMaxScore="40"
                            :rightScore="20"
                            :rightMinTxt="''"
                            :rightMaxTxt="''"
                            />
                        </div>
                    </div>
                    
                    <div class="title">供应链减排措施的采纳及成效</div>
                    <div class="chartArea" v-if="PdftStore.fromData.spaceEmissionGreenSupply">
                        <div class="logo">
                            <img :src="'/api/fileSystem/file/download?fileId='+PdftStore.fromData.orgInfo?.logoId" alt="">
                        </div>
                        <div class="page10chart1">
                            <Pie 
                            :id="'page10chart1'" 
                            :data="[
                                { value: 100 - PdftStore.fromData.spaceEmissionGreenSupply?.planScore || 0, name: 'Plan Engine' },
                                { value: PdftStore.fromData.spaceEmissionGreenSupply?.planScore || 0, name: 'Plan Direct' }]"
                                >
                            </Pie>
                            <div class="name">
                                <span>计划:</span>
                                <span>{{PdftStore.fromData.spaceEmissionGreenSupply?.planScore || 0}}分</span>
                            </div>
                        </div>
                        <div class="page10chart2">
                            <Pie 
                            :id="'page10chart2'" 
                            :center="['65%', '35%']" 
                            :data="[
                                { value: 100 - PdftStore.fromData.spaceEmissionGreenSupply?.targetScore || 0, name: 'Objective Engine' },
                                { value: PdftStore.fromData.spaceEmissionGreenSupply?.targetScore || 0, name: 'Objective Direct' }]"
                                >
                            </Pie>
                            <div class="name">
                                <span>目标:</span>
                                <span>{{PdftStore.fromData.spaceEmissionGreenSupply?.targetScore || 0}}分</span>
                            </div>
                        </div>
                        <div class="page10chart3">
                            <Pie 
                            :id="'page10chart3'" 
                            :center="['35%', '45%']" 
                            :data="[
                                { value: 100 - PdftStore.fromData.spaceEmissionGreenSupply?.effectScore || 0, name: 'Action Engine' },
                                { value: PdftStore.fromData.spaceEmissionGreenSupply?.effectScore || 0, name: 'Action Direct' }]"
                                >
                            </Pie>
                            <div class="name">
                                <span>成效:</span>
                                <span>{{PdftStore.fromData.spaceEmissionGreenSupply?.effectScore || 0}}分</span>
                            </div>
                        </div>
                        <div class="page10chart4">
                            <Pie 
                            :id="'page10chart4'" 
                            :center="['65%', '45%']" 
                            :data="[
                                { value: 100 - PdftStore.fromData.spaceEmissionGreenSupply?.actionScore || 0, name: 'Result Engine' },
                                { value: PdftStore.fromData.spaceEmissionGreenSupply?.actionScore || 0, name: 'Result Direct' }]"
                                >
                            </Pie>
                            <div class="name">
                                <span>行动:</span>
                                <span>{{PdftStore.fromData.spaceEmissionGreenSupply?.actionScore || 0}}分</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="right_box">
                    <div class="top_box_banner">
                        <div class="title">评分逻辑</div>
                        <div class="txt">{{PdftStore.fromData.spaceEmissionGreenSupply?.scoreStandard}}</div>
                    </div>
                    <div class="title">碳中和进程评级综合表现</div>
                    <div class="ec_t" v-if="PdftStore.fromData.spaceEmissionGreenSupply">
                        <Echarts :name="'page10echarts'" :type="'f'"/>
                    </div>
                </div>
            </div>
            <!-- 底部 -->
            <Bottoms/>
            <div class="flxed">08</div>
        </div>
    </div>
</template>

<script>
import { reactive, toRefs, onBeforeMount, onMounted } from 'vue'
import { useRoute, useRouter } from 'vue-router';
import Headers from '../components/headers.vue'
import Bottoms from '../components/bottoms.vue'
import List from '../components/list.vue'
import NewPro from '../components/newPro.vue'
import Pie from '../components/pie.vue'
import Echarts from '../components/echarts.vue'
import { usePdftStore } from '@/store/pdf'
import { formatDateTimeYYmm, formatDateTimeYY } from '@/utils/date'
export default {
    name: 'page10',
    components:{Headers, Bottoms, List, NewPro, Pie, Echarts},
    setup() {
        const data = reactive({
            xdata:{
                name:'绿色减\n排措施',
                data:['A','B','C','D','E','F']
            },
            ydata:{
                name:'企业数量',
                type:0
            },
            series:{
                data:[
                    {
                        value:12,
                        type: 'bar',
                        name:'A'
                    }, 
                    {
                        value:6,
                        type: 'bar',
                        name:'B'
                    },  
                    {
                        value:9,
                        type: 'bar',
                        name:'C'
                    },  
                    {
                        value:16,
                        type: 'bar',
                        name:'D'
                    }, 
                    {
                        value:5,
                        type: 'bar',
                        name:'E'
                    },  
                    {
                        value:7,
                        type: 'bar',
                        name:'F'
                    },  
                ],
                title:"隆基股份采用的供应链减排措施",
            },
        })
        //引入数据管理库
        const PdftStore = usePdftStore()
        const formatDateTimeYYmms = (str) => {
            return formatDateTimeYYmm(str)
        }
        const formatDateTimeYYs = (str) => {
            return formatDateTimeYY(str)
        }
        onBeforeMount(() => {})
        onMounted(() => {})
        return {
            PdftStore,
            formatDateTimeYYmms,
            formatDateTimeYYs,
            ...toRefs(data),
        }
    },
}

</script>
<style scoped lang='less'>
.mag_t{
    margin-top: 20px;
}
.margin_t{
    margin-top: 10px;
}
.page{
    width: 1512px;
    height: 2149px;
    margin: 0 auto;
    background: #FFFFFF;
    position: relative;
    .banner{
        width: 100%;
        padding: 0 130px;
        .mg_t{
            margin-top: 96px;
        }
        .flxed{
            position: absolute;
            right: 20px;
            bottom: 20px;
            font-size: 24px;
            font-weight: 400;
            color: #333333;
            line-height: 33px;
        }
        .top_box{
            margin-top: 50px;
            display: flex;
            justify-content: stretch;
            .title{
                font-size: 28px;
                font-weight: bold;
                color: #333333;
                line-height: 42px;
            }
            .left{
                width: 100%;
                flex: 1;
                .mg_b{
                    margin-bottom: 20px;
                }
                .txt{
                    font-size: 32px;
                    font-weight: 500;
                    line-height: 36px;
                    color: #333333;
                    white-space: normal;
                    word-wrap: break-word;
                }
                .tx{
                    margin-top: 15px;
                    font-size: 16px;
                    text-align: justify;
                    line-height: 24px;
                    font-weight: 400;
                    color: #666666;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            .right{
                width: calc(100% - 710px);
                padding-left: 40px;
                border-left: 1px solid #C5C5C6;
                .txt{
                    font-size: 16px;
                    font-weight: 400;
                    text-align: justify;
                    color: #333333;
                    line-height: 24px;
                    margin-top: 23px;
                    white-space: normal;
                    word-wrap: break-word;
                }
            }
            
        }
        .min_box{
            margin-top: 55px;
            font-size: 24px;
            font-weight: 500;
            color: #333333;
            line-height: 42px;
            .title{
                margin-bottom: 33px;
                font-weight: bold;
            }
        }
    }
}
.banner_box{
    display: flex;
    width: 100%;
    height: 900px;
    margin-top: 30px;
    justify-content: stretch;
    .left_box{
        width: 670px;
        padding-right: 40px;
        border-right: 1px dashed #C5C5C6;
        flex: 1;
    }
    .right_box{
        width: calc(100% - 670px);
        flex: 1;
        padding-left: 40px;
    }
    .top_box_banner{
        height: 350px;
    }
    .title{
        font-size: 28px;
        font-weight: bold;
        color: #333333;
        line-height: 42px;
    }
    .jindu{
        height: calc(350px - 42px);
        width: 100%;
        display: flex;
        align-items: center;
    }
    .mg_top{
        margin-top: 90px;
    }
    .ec_t{
        margin-top: 10px;
        width: 100%;
        height: 413px;
    }
    .txt{
        font-size: 16px;
        font-weight: 400;
        text-align: justify;
        color: #333333;
        line-height: 24px;
        margin-top: 10px;
        white-space: normal;
        word-wrap: break-word;
    }
    .txt_s{
        color: #999999;
    }
}

.chartArea {
        width: 516px;
        height: 446px;
        margin-top: 50px;
        background-image: url('@/assets/img/reportBg.png');
        background-size: 100% 100%;
        position: relative;
        .logo{
            position: absolute;
            max-width: 60px;
            max-height: 60px;
            display: flex;
            justify-content: center;
            align-items: center;
            z-index: 999;
            top: 50%; /* 垂直居中 */
            left: 50%; /* 水平居中 */
            transform: translate(-50%, -50%); /* 以自身宽高的一半为偏移量，实现居中 */
            img{
                width: auto;
                max-width: 60px;
                height: auto;
                max-height: 60px;
            }
        }
        &>div {
            position: absolute;
            width: 220px;
            height: 220px;

            .name {
                position: absolute;
                bottom: 20px;
                width: 160px;
                text-align: center;

                &>span:nth-child(1) {
                    font-family: Arial, Arial;
                    font-weight: bold;
                    font-size: 14px;
                    color: #00142A;
                    line-height: 16px;
                }

                &>span:nth-child(2) {
                    font-family: Arial, Arial;
                    font-weight: bold;
                    font-size: 14px;
                    color: #333333;
                    line-height: 16px;
                }
            }
        }

        .page10chart1 {
            left: 0;
            top: 0;
        }

        .page10chart2 {
            right: 0;
            top: 0;

            .name {
                right: 0;
            }
        }

        .page10chart3 {
            left: 0;
            bottom: 0;

            .name {
                bottom: 10px;
            }
        }

        .page10chart4 {
            right: 0;
            bottom: 0;

            .name {
                bottom: 10px;
                right: 0;
            }
        }
    }
</style>